module.exports = __webpack_public_path__ + "img/yehuda.5b010bcc.png";